(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp-product-hero"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('.bp-hero')
  if (root) {
    const carousel = root.querySelector('[data-bp-carousel]')
    const track = root.querySelector('[data-bp-track]')
    const slides = Array.from(root.querySelectorAll('.bp-hero__slide'))
    const thumbs = Array.from(root.querySelectorAll('.bp-hero__thumb'))
    const dots = Array.from(root.querySelectorAll('.bp-hero__dot'))
    let index = Number(carousel?.getAttribute('data-index') || 0)
    if (Number.isNaN(index) || index < 0) index = 0
    if (slides.length && index > slides.length - 1) index = slides.length - 1

    const syncThumbs = (nextIndex) => {
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === nextIndex))
      const activeSlide = slides[nextIndex]
      const activeId = activeSlide?.getAttribute('data-media-id')
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === nextIndex
        slide.classList.toggle('is-active', active)
        slide.setAttribute('aria-hidden', active ? 'false' : 'true')
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause())
      })
      thumbs.forEach((thumb) => {
        const active = thumb.getAttribute('data-media-id') === activeId
        thumb.classList.toggle('is-active', active)
        thumb.setAttribute('aria-selected', active ? 'true' : 'false')
        if (active && typeof thumb.scrollIntoView === 'function') {
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' })
        }
      })
    }

    const total = slides.length
    const wrap = (value) => ((value % total) + total) % total

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) root.querySelectorAll('.bp-hero__slide video').forEach((video) => video.pause())
    })

    // Pour boucler sans coupure, la diapo opposée est déplacée au-delà du bord
    // le temps de la transition, puis tout revient à sa place sans animation.
    let edgeMode = null
    let settleTimer = null

    const setEdge = (mode) => {
      if (mode === edgeMode || total < 2) return
      edgeMode = mode
      slides.forEach((slide) => { slide.style.transform = '' })
      if (mode === 'next') slides[0].style.transform = `translateX(${total * 100}%)`
      if (mode === 'prev') slides[total - 1].style.transform = `translateX(-${total * 100}%)`
    }

    const applyTransform = (position, animate) => {
      if (!animate) track.classList.add('is-dragging')
      track.style.transform = `translate3d(${position * -100}%, 0, 0)`
      if (!animate) {
        track.offsetHeight
        track.classList.remove('is-dragging')
      }
    }

    const goTo = (nextIndex, { animate = true } = {}) => {
      if (!track || !slides.length) return
      window.clearTimeout(settleTimer)
      if (total < 2) {
        index = 0
        applyTransform(0, false)
        syncThumbs(0)
        return
      }
      const target = wrap(nextIndex)
      let position = target
      if (nextIndex >= total) {
        setEdge('next')
        position = total
      } else if (nextIndex < 0) {
        setEdge('prev')
        position = -1
      } else if (edgeMode) {
        // Retour au même bord : la diapo voisine reste en place le temps du rappel
        settleTimer = window.setTimeout(() => setEdge(null), animate ? 340 : 0)
      } else {
        setEdge(null)
      }
      index = target
      if (carousel) carousel.setAttribute('data-index', String(index))
      applyTransform(position, animate)
      syncThumbs(index)
      if (position !== target) {
        settleTimer = window.setTimeout(() => {
          setEdge(null)
          applyTransform(target, false)
        }, animate ? 340 : 0)
      }
    }

    if (carousel && track && slides.length > 1) {
      let pointerId = null
      let startX = 0
      let startY = 0
      let deltaX = 0
      let dragging = false
      let lockedAxis = null
      let lastX = 0
      let lastT = 0
      let velocity = 0
      // Navigateur intégré Facebook : le swipe qui revient à l'image précédente
      // est le même geste que « quitter la page ». On ne l'utilise plus ici.
      const isFacebookBrowser = /FBAN|FBAV|FB_IAB|FB4A|FBIOS/i.test(navigator.userAgent || '')

      const width = () => carousel.getBoundingClientRect().width || 1

      const lockHorizontal = () => {
        dragging = true
        carousel.classList.add('is-dragging')
        track.classList.add('is-dragging')
        if (pointerId != null) {
          try { carousel.setPointerCapture(pointerId) } catch (error) {}
        }
      }

      const handlePointerDown = (event) => {
        if (event.button != null && event.button !== 0) return
        if (event.target.closest('video, iframe, a, button')) return
        pointerId = event.pointerId
        startX = event.clientX
        startY = event.clientY
        lastX = startX
        lastT = performance.now()
        deltaX = 0
        velocity = 0
        dragging = false
        lockedAxis = null
      }

      const handlePointerMove = (event) => {
        if (pointerId == null || event.pointerId !== pointerId) return
        const dx = event.clientX - startX
        const dy = event.clientY - startY
        if (!lockedAxis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return
          // Le défilement vertical de la page gagne, sauf si le geste est nettement horizontal.
          lockedAxis = Math.abs(dx) > Math.abs(dy) * 1.25 ? 'x' : 'y'
          if (lockedAxis === 'y') {
            pointerId = null
            return
          }
          if (isFacebookBrowser && dx > 0) {
            pointerId = null
            lockedAxis = null
            return
          }
          lockHorizontal()
        }
        if (lockedAxis !== 'x') return
        if (isFacebookBrowser && dx > 0) {
          deltaX = 0
          track.style.transform = `translate3d(${-index * width()}px, 0, 0)`
          return
        }
        if (event.cancelable) event.preventDefault()
        deltaX = dx
        const now = performance.now()
        const dt = Math.max(1, now - lastT)
        velocity = (event.clientX - lastX) / dt
        lastX = event.clientX
        lastT = now
        if (deltaX < 0 && index === total - 1) setEdge('next')
        else if (!isFacebookBrowser && deltaX > 0 && index === 0) setEdge('prev')
        else setEdge(null)
        const offset = -index * width() + deltaX
        track.style.transform = `translate3d(${offset}px, 0, 0)`
      }

      const handlePointerUp = (event) => {
        if (pointerId == null || event.pointerId !== pointerId) return
        if (carousel.hasPointerCapture?.(pointerId)) carousel.releasePointerCapture(pointerId)
        pointerId = null
        carousel.classList.remove('is-dragging')
        track.classList.remove('is-dragging')
        if (!dragging || lockedAxis !== 'x') {
          lockedAxis = null
          dragging = false
          goTo(index)
          return
        }
        const threshold = Math.max(36, width() * 0.12)
        const flicked = Math.abs(velocity) > 0.32
        let next = index
        if ((deltaX < -threshold) || (flicked && velocity < -0.15)) next = index + 1
        else if (!isFacebookBrowser && ((deltaX > threshold) || (flicked && velocity > 0.15))) next = index - 1
        lockedAxis = null
        dragging = false
        deltaX = 0
        goTo(next)
      }

      if (isFacebookBrowser) {
        carousel.classList.add('is-fb-browser')
        const previousButton = document.createElement('button')
        previousButton.type = 'button'
        previousButton.className = 'bp-hero__prev'
        previousButton.setAttribute('aria-label', carousel.getAttribute('data-bp-prev-label') || 'Previous')
        previousButton.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M14.5 5.5L8 12l6.5 6.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        previousButton.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()
          goTo(index - 1)
        })
        carousel.appendChild(previousButton)
      }

      carousel.addEventListener('pointerdown', handlePointerDown)
      carousel.addEventListener('pointermove', handlePointerMove, { passive: false })
      carousel.addEventListener('pointerup', handlePointerUp)
      carousel.addEventListener('pointercancel', handlePointerUp)
      carousel.addEventListener('lostpointercapture', handlePointerUp)
      carousel.addEventListener('dragstart', (event) => event.preventDefault())

      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault()
          goTo(index + 1)
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault()
          goTo(index - 1)
        }
      })

      goTo(index, { animate: false })
    }

    thumbs.forEach((thumb) => {
      const handleThumbClick = () => {
        const id = thumb.getAttribute('data-media-id')
        const nextIndex = slides.findIndex((slide) => slide.getAttribute('data-media-id') === id)
        if (nextIndex < 0) return
        goTo(nextIndex)
      }
      thumb.addEventListener('click', handleThumbClick)
    })

    const colorGroup = root.querySelector('[data-bp-color-switcher]')
    if (colorGroup) {
      const otherUrl = colorGroup.getAttribute('data-other-url')
      const otherImage = colorGroup.getAttribute('data-other-image')
      const warmed = new Set()

      const ensureLink = (rel, href, asValue) => {
        if (!href || warmed.has(`${rel}:${href}`)) return
        warmed.add(`${rel}:${href}`)
        const link = document.createElement('link')
        link.rel = rel
        link.href = href
        if (asValue) link.as = asValue
        document.head.appendChild(link)
      }

      const warmAlternate = (eager = false) => {
        if (!otherUrl) return
        ensureLink('prefetch', otherUrl, 'document')
        if (eager) ensureLink('prerender', otherUrl)
        if (otherImage) {
          const img = new Image()
          img.decoding = 'async'
          img.src = otherImage
        }
        if (eager && HTMLScriptElement.supports?.('speculationrules')) {
          const abs = new URL(otherUrl, window.location.origin).href
          if (!warmed.has(`spec:${abs}`)) {
            warmed.add(`spec:${abs}`)
            const spec = document.createElement('script')
            spec.type = 'speculationrules'
            spec.textContent = JSON.stringify({
              prerender: [{ source: 'list', urls: [abs], eagerness: 'eager' }]
            })
            document.head.appendChild(spec)
          }
        }
        try {
          fetch(otherUrl, {
            credentials: 'same-origin',
            priority: eager ? 'high' : 'low'
          }).catch(() => {})
        } catch (error) {}
      }

      const scheduleWarm = () => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => warmAlternate(false), { timeout: 1200 })
        } else {
          setTimeout(() => warmAlternate(false), 400)
        }
      }

      scheduleWarm()
      ;['pointerenter', 'focusin', 'touchstart'].forEach((eventName) => {
        colorGroup.addEventListener(eventName, () => warmAlternate(true), { passive: true, once: false })
      })

      const colorLinks = colorGroup.querySelectorAll('[data-bp-color]')
      colorLinks.forEach((link) => {
        link.addEventListener('pointerenter', () => {
          if (!link.classList.contains('is-active')) warmAlternate(true)
        }, { passive: true })

        link.addEventListener('click', (event) => {
          if (link.classList.contains('is-active')) {
            event.preventDefault()
            return
          }
          warmAlternate(true)
          const bg = getComputedStyle(root).getPropertyValue('--bp-hero-bg').trim() || '#f1f1f1'
          let veil = document.getElementById('bp-color-nav-veil')
          if (!veil) {
            veil = document.createElement('div')
            veil.id = 'bp-color-nav-veil'
            veil.setAttribute('aria-hidden', 'true')
            veil.style.cssText = `position:fixed;inset:0;z-index:2147483646;background:${bg};opacity:0;pointer-events:none;transition:opacity 70ms linear`
            document.body.appendChild(veil)
            requestAnimationFrame(() => {
              veil.style.opacity = '1'
            })
          }
        })

        link.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return
          event.preventDefault()
          const nextKey = event.key === 'ArrowRight' ? 'b' : 'a'
          const nextLink = colorGroup.querySelector(`[data-bp-color="${nextKey}"]`)
          if (!nextLink) return
          nextLink.focus()
          if (nextLink.href && !nextLink.classList.contains('is-active')) {
            warmAlternate(true)
            window.location.href = nextLink.href
          }
        })
      })
    }


    const sticky = root.querySelector('[data-bp-sticky]')
    const mainButton = root.querySelector('[data-bp-bundle-atc]') || root.querySelector('form .bp-hero__atc, .bp-hero__atc:not(.bp-hero__sticky-atc)')
    const stickyButton = sticky && sticky.querySelector('[data-bp-sticky-atc]')
    if (sticky && mainButton && stickyButton) {
      const GAP = 40
      let passed = false
      const inView = (el) => {
        if (!el) return false
        const box = el.getBoundingClientRect()
        return box.bottom > GAP && box.top < window.innerHeight - GAP
      }
      const overlayOpen = () => {
        if (document.querySelector('cart-drawer[open]')) return true
        if (document.querySelector('navigation-drawer[open]')) return true
        if (document.querySelector('dialog.bp-ugcp[open]')) return true
        const privacy = document.querySelector('privacy-bar')
        return Boolean(privacy && privacy.hidden === false)
      }
      const update = () => {
        const bottom = mainButton.getBoundingClientRect().bottom
        if (bottom < -GAP) passed = true
        if (bottom > GAP) passed = false
        const hide = passed === false
          || inView(document.querySelector('[data-bp-close-cta]'))
          || inView(document.querySelector('.bp-close'))
          || inView(document.querySelector('.footer'))
          || overlayOpen()
        sticky.classList.toggle('is-visible', hide === false)
        sticky.setAttribute('aria-hidden', hide ? 'true' : 'false')
        stickyButton.disabled = mainButton.disabled
      }
      const handleStickyClick = () => {
        mainButton.click()
      }
      stickyButton.addEventListener('click', handleStickyClick)
      new MutationObserver(update).observe(mainButton, { attributes: true })
      new MutationObserver(update).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open', 'hidden'] })
      window.addEventListener('scroll', update, { passive: true })
      window.addEventListener('resize', update)
      document.addEventListener('cart:refresh', update)
      update()
    }


    const variantInput = root.querySelector('[data-bp-variant-input]')
    const optionInputs = root.querySelectorAll('[data-bp-option]')
    const script = root.parentElement.querySelector('[data-bp-variants]')
    if (variantInput && optionInputs.length && script) {
      const variants = JSON.parse(script.textContent)
      const handleOptionChange = () => {
        const selected = []
        optionInputs.forEach((input) => {
          if (input.checked) selected[Number(input.getAttribute('data-bp-option')) - 1] = input.value
        })
        const next = variants.find((variant) => {
          return (
            (variant.option1 || null) === (selected[0] || null) &&
            (variant.option2 || null) === (selected[1] || null) &&
            (variant.option3 || null) === (selected[2] || null)
          )
        })
        if (next) {
          variantInput.value = next.id
        }
      }
      optionInputs.forEach((input) => input.addEventListener('change', handleOptionChange))
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bp-quotes]').forEach((track) => {
    const section = track.closest('.bp-quotes')
    const arrows = section ? section.querySelectorAll('.bp-quotes__arrow') : []

    const syncArrows = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 1
      arrows.forEach((button) => {
        const dir = Number(button.getAttribute('data-dir'))
        const atStart = dir < 0 && track.scrollLeft <= 0
        const atEnd = dir > 0 && track.scrollLeft >= maxScroll
        button.disabled = atStart || atEnd
      })
    }

    arrows.forEach((button) => {
      button.addEventListener('click', () => {
        const dir = Number(button.getAttribute('data-dir'))
        const card = track.querySelector('.bp-quotes__card')
        const step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.85
        track.scrollBy({ left: dir * step, behavior: 'smooth' })
      })
    })

    track.addEventListener('scroll', syncArrows, { passive: true })
    window.addEventListener('resize', syncArrows, { passive: true })
    syncArrows()

    track.querySelectorAll('[data-bp-quote-more]').forEach((button) => {
      const text = button.parentElement.querySelector('[data-bp-quote-text]')
      if (!text) return

      const revealIfClamped = () => {
        if (button.getAttribute('aria-expanded') === 'true') return
        button.hidden = text.scrollHeight - text.clientHeight <= 2
      }

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true'
        text.classList.toggle('is-expanded', !expanded)
        button.setAttribute('aria-expanded', String(!expanded))
        button.textContent = expanded
          ? button.getAttribute('data-label-more')
          : button.getAttribute('data-label-less')
        syncArrows()
      })

      revealIfClamped()
      window.addEventListener('resize', revealIfClamped, { passive: true })
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(revealIfClamped)
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-trust"] && !Shopify.designMode) return;
  try {
    
  if (!window.__bpTrustCtaBound) {
    window.__bpTrustCtaBound = true
    const handleClick = (event) => {
      const link = event.target.closest('[data-bp-trust-cta]')
      if (!link) return
      const href = link.getAttribute('href')
      if (!href || href.charAt(0) !== '#') return
      const id = href.slice(1)
      if (!id) return
      const target = document.getElementById(id)
      if (!target) return
      event.preventDefault()
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    document.addEventListener('click', handleClick)
  }

  } catch(e) { console.error(e); }
})();
})();
